// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var VisuallyHidden = require("@reach/visually-hidden").default;

function IconButton(props) {
  var __className = props.className;
  var __disabled_ = props.disabled;
  var onPress = props.onPress;
  var disabled_ = __disabled_ !== undefined ? __disabled_ : false;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
              onClick: (function (param) {
                  onPress();
                }),
              disabled: disabled_,
              className: TailwindMerge.twMerge([
                    "border border-zinc-300 rounded-[20px] cursor-pointer p-1.5 text-zinc-400 disabled:border-zinc-200 disabled:bg-zinc-50 disabled:text-zinc-300 hover:bg-zinc-100 hover:text-zinc-500",
                    className
                  ]),
              children: Caml_option.some(JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx(VisuallyHidden, {
                                children: props.title
                              }),
                          JsxRuntime.jsx("span", {
                                children: JsxRuntime.jsx(IconV5.make, {
                                      icon: props.icon
                                    }),
                                "aria-hidden": true,
                                className: "flex"
                              })
                        ]
                      }))
            });
}

var make = IconButton;

exports.make = make;
/* IconV5 Not a pure module */
